import { PaymentLock } from '@/utils/paymentLock'

type PaymentLockListener = (paymentLock: PaymentLock) => void

// Bridge from the RTK base query (no React context there) to the UI:
// services/local.ts notifies, PaymentLockWatcher decides toast vs popup.
const listeners = new Set<PaymentLockListener>()

export const onPaymentLock = (listener: PaymentLockListener) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

// Returns false when nothing is listening, so the caller can fall back.
export const notifyPaymentLock = (paymentLock: PaymentLock): boolean => {
  listeners.forEach((listener) => listener(paymentLock))
  return listeners.size > 0
}
